import { connect } from 'react-redux';
import utils from 'utils';
import BranchLocationTimeDrawer from './BranchLocationTimeDrawer';

const mapStateToProps = (state, ownProps) => ({
  hoursForStore: state.getIn(['gmi', 'solr', 'hours', ownProps.id, 'data']) || null,
});

export default connect(mapStateToProps)(utils.toJS(BranchLocationTimeDrawer));
